<template>
  <div>
  <v-select 
  :class="data.class"
  :disabled="data.disabled"
  :options="data.options"
  label="text" 
  v-model="valueInput">
    <template #search="{attributes, events}">
      <input
        class="vs__search"
        :required="!valueInput"
        v-bind="attributes"
        v-on="events"
      />
    </template>
    <template #no-options>Nenhum dado encontrado.</template>
  </v-select>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';

import vSelect from 'vue-select'

export default {
  components: {
      vSelect
  },
  props: {
    data: {
      type: Object,
    },
    value: {
      required: true
    }
  },
  computed: {
    valueInput: {
      get () {
        if (this.value === undefined || this.value === '' || this.value === null) return null
        else return this.data.options.find(x => x.value === this.value)
      },
      set (value) {
        this.$emit('input', value?.value)
      }
    }
  }
};
</script>
<style lang="scss">
.v-select {
  height: 40px;
  .vs__dropdown-toggle {
    height: 40px;
  }
  .vs__actions {
    display: flex;
    justify-content: center;
    align-items: center;
    .vs__clear {
      display: grid;
      place-items: center;
      fill: red;
    }
  }
}
</style>